// src/context/ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();
const THEMES = ["light", "medium", "dark"];

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Si ya eligió uno antes lo respeta, si no inicia en "medium"
    return localStorage.getItem("cec_theme") || "medium";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("cec_theme", theme);
  }, [theme]);

  const cycleTheme = () => {
    const idx = THEMES.indexOf(theme);
    setTheme(THEMES[(idx + 1) % THEMES.length]);
  };

  return (
    <ThemeContext.Provider value={{ theme, cycleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
